/* eslint-disable import/no-extraneous-dependencies */
import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props, union } from '@ngrx/store';
import {
  BuyerAccountInformation,
  PaymentPreviewErrorPayload,
  PaymentPreviewV1Response,
  PaymentProcess,
  PayOnAccountPaymentPreviewV1Response,
  PayOtherAmountV1Response,
  TransactionAuthorizationResult,
} from '@arc/unified-payments-frontend/shared-payment';

export const UpdatePaymentPreviewAction = createAction(
  '[BtPay Payment Information] Update Payment Preview Action',
);

export const UpdatePaymentPreviewCompleteAction = createAction(
  '[BtPay Payment Information] Update Payment Preview Complete Action',
  props<{ payload: PaymentPreviewV1Response }>(),
);

export const UpdatePayOtherAmountAction = createAction(
  '[BtPay Payment Information] Update Pay Other Action',
);

export const UpdatePayOtherAmountCompleteAction = createAction(
  '[BtPay Payment Information] Update Pay Other Complete Action',
  props<{ payload: PayOtherAmountV1Response }>(),
);

export const UpdatePaymentPreviewErrorAction = createAction(
  '[BtPay Payment Information] Update Payment Preview Error Action',
  props<{ payload: HttpErrorResponse }>(),
);

export const UpdatePayOtherAmountErrorAction = createAction(
  '[BtPay Payment Information] Update Pay Other Amount Error Action',
  props<{ payload: HttpErrorResponse }>(),
);

export const CreatePaymentPreviewAction = createAction(
  '[BtPay Payment Information] Create Payment Preview Action',
);

export const CreatePaymentPreviewCompleteAction = createAction(
  '[BtPay Payment Information] Create Payment Preview Complete Action',
  props<{ payload: PaymentPreviewV1Response }>(),
);

export const CreatePaymentPreviewErrorAction = createAction(
  '[BtPay Payment Information] Create Payment Preview Error Action',
  props<{ emptyPayables: boolean }>(),
);

export const CreatePaymentPreviewAllPayablesPaidInFullAction = createAction(
  '[BtPay Payment Information] Create Payment Preview All Payables Paid In Full Action',
  props<{ payload: HttpErrorResponse }>(),
);

export const CreatePayOnAccountPaymentPreviewCompleteAction = createAction(
  '[BtPay Payment Information] Create Pay On Account Payment Preview Complete Action',
  props<{ payload: PayOnAccountPaymentPreviewV1Response }>(),
);

export const CreatePayOnAccountPaymentPreviewErrorAction = createAction(
  '[BtPay Payment Information] Create Pay On Account Payment Preview Error Action',
);

export const SubmitPaymentPreviewAction = createAction(
  '[BtPay Payment Information] Submit Payment Preview Action',
  props<{
    paymentProcess: PaymentProcess;
  }>(),
);

export const SubmitPaymentPreviewCompleteAction = createAction(
  '[BtPay Payment Information] Submit Payment Preview Complete Action',
  props<{
    payload: PaymentPreviewV1Response;
    paymentProcess: PaymentProcess;
  }>(),
);

export const SubmitPaymentPreviewErrorAction = createAction(
  '[BtPay Payment Information] Submit Payment Preview Error Action',
  props<{ payload: HttpErrorResponse }>(),
);

export const UpdatePaymentReferenceAction = createAction(
  '[BtPay Payment Information] Update Payment Reference Action',
);

export const GetSurchargeAmountAction = createAction(
  '[BtPay Payment Information] Get Surcharge Amount Action',
);

export const GetSurchargeAmountSuccessAction = createAction(
  '[BtPay Payment Information] Get Surcharge Amount Success Action',
  props<{ payload: PaymentPreviewV1Response }>(),
);

export const GetSurchargeAmountErrorAction = createAction(
  '[BtPay Payment Information] Get Surcharge Amount Error Action',
  props<{
    payload: PaymentPreviewErrorPayload;
  }>(),
);

export const DisplaySurchargeAmountErrorAction = createAction(
  '[BtPay Payment Information] Display Surcharge Amount Error Action',
  props<{
    payload: PaymentPreviewErrorPayload;
  }>(),
);

export const GetSurchargeAmountDismissErrorAction = createAction(
  '[BtPay Payment Information] Get Surcharge Amount Dismiss Error Action',
);

export const RecalculateSurchargeDismissedAction = createAction(
  '[BtPay Payment Information] Recalculate Surcharge Dismissed Action',
);

export const ClearSurchargeAmountAction = createAction(
  '[BtPay Payment Information] Clear Surcharge Amount Action',
);

export const ClearSurchargeErrorAction = createAction(
  '[BtPay Payment Information] Clear Surcharge Error Action',
);

export const ExecuteSingleTransactionPaymentPreviewAction = createAction(
  '[BtPay Payment Information] Execute Single Transaction Payment Preview Action',
);

export const ExecutePaymentPreviewSuccessAction = createAction(
  '[BtPay Payment Information] Execute Payment Preview Success Action',
  props<{
    transactionReference: string;
    result: TransactionAuthorizationResult;
  }>(),
);

export const ExecutePaymentPreviewBadRequestErrorAction = createAction(
  '[BtPay Payment Information] Execute Payment Preview Bad Request Error Action',
  props<{ payload: HttpErrorResponse }>(),
);

export const ExecutePaymentPreviewServerErrorAction = createAction(
  '[BtPay Payment Information] Execute Payment Preview Server Error Action',
  props<{ payload: HttpErrorResponse }>(),
);

export const GetBuyerAccountsAction = createAction(
  '[BtPay Payment Information] Get Buyer Accounts Action',
);

export const GetBuyerAccountsSuccessAction = createAction(
  '[BtPay Payment Information] Get Buyer Accounts Success Action',
  props<{ buyerAccounts: BuyerAccountInformation[] }>(),
);

export const GetBuyerAccountsErrorAction = createAction(
  '[BtPay Payment Information] Get Buyer Accounts Error Action',
);

const BtPayPaymentInformationActions = union({
  UpdatePaymentPreviewAction,
  UpdatePaymentPreviewCompleteAction,
  UpdatePayOtherAmountAction,
  UpdatePayOtherAmountCompleteAction,
  UpdatePaymentPreviewErrorAction,
  CreatePaymentPreviewAction,
  CreatePaymentPreviewCompleteAction,
  CreatePaymentPreviewErrorAction,
  CreatePaymentPreviewAllPayablesPaidInFullAction,
  SubmitPaymentPreviewAction,
  SubmitPaymentPreviewCompleteAction,
  SubmitPaymentPreviewErrorAction,
  ExecutePaymentPreviewAction: ExecuteSingleTransactionPaymentPreviewAction,
  ExecutePaymentPreviewSuccessAction,
  ExecutePaymentPreviewErrorAction: ExecutePaymentPreviewBadRequestErrorAction,
  UpdatePaymentReferenceAction,
  GetSurchargeAmountAction,
  GetSurchargeAmountSuccessAction,
  GetSurchargeAmountErrorAction,
  GetSurchargeAmountDismissErrorAction,
  DisplaySurchargeAmountErrorAction,
  ClearSurchargeAmountAction,
  RecalculateSurchargeDismissedAction,
  GetBuyerAccountsAction,
  GetBuyerAccountsSuccessAction,
  GetBuyerAccountsErrorAction,
  CreatePayOnAccountPaymentPreviewCompleteAction,
  CreatePayOnAccountPaymentPreviewErrorAction,
});

export type BtPayPaymentInformationActionsUnion =
  typeof BtPayPaymentInformationActions;
